<template>
    <div id="add-rule">
        <form id="form-data-rules" v-on:submit.prevent="validateSubmit">
            <div class="form-group">
                <ejs-dropdownlist name="prefix" v-model="formData.prefix" :dataSource="dataList" placeholder="Prefijo:"></ejs-dropdownlist>
            </div>
            <div class="form-group">
                <ejs-textbox name="article" v-model="formData.article" placeholder="Prefijo número:" data-msg-containerid="formUsersError2"></ejs-textbox>
            </div>
            <div class="form-group">
                <ejs-dropdownlist name="standard_type" v-model="formData.standard_type" :fields="fieldStandard" :dataSource="listStandard"  placeholder="Tipo norma:"></ejs-dropdownlist>
            </div>
            <div class="form-group">
                <ejs-textbox  name="number" v-model="formData.number" placeholder="Número:"></ejs-textbox>
            </div>
            <div class="form-group">
                <ejs-textbox name="year" v-model="formData.year" placeholder="Año:"></ejs-textbox>
            </div>
            <div class="form-group">
                <ejs-textbox name="denomination" v-model="formData.denomination" placeholder="Denominación:" data-msg-containerid="formUsersError2"></ejs-textbox>
            </div>
            <div class="form-group">
                <ejs-dropdownlist 
                name="tenant"
                 v-model="formData.tenant" 
                :dataSource="tenants" 
                :fields="fieldsSourceProcess"
                placeholder="Seleccione un tenant:"></ejs-dropdownlist>
            </div>
            <div class="form-group">
                <div class="control-section">
                    <div class="sample-container">
                        <div class="default-section">
                            <ejs-richtexteditor 
                                v-model="formData.content" 
                                ref="defaultRTE" 
                                :height="400" 
                                :value="formData.content" 
                                :quickToolbarSettings="quickToolbarSettings" 
                                :toolbarSettings="toolbarSettings"
                                @imageSelected="imageSelected"
                            >
                            </ejs-richtexteditor>
                        </div>
                    </div>
                </div>
            </div>
            <ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtnFormUsers" :disabled="disabledButton" :spinSettings="spinSettings" :progress="progress" :duration="10000">Guardar</ejs-progressbutton>
        </form>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios'
import { ProgressButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar } from "@syncfusion/ej2-vue-richtexteditor";

Vue.use(RichTextEditorPlugin);
Vue.use(ProgressButtonPlugin);
Vue.use(NumericTextBoxPlugin);

export default {
    name: 'add-rule',
    provide: {
        richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar]
    },
    props: ['data'],
    data() {
        return {
            quickToolbarSettings: {
                image: [
                    'Replace', 'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-',
                    'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension',
                    ]
            },
             toolbarSettings: {
                items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
                    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
                    'LowerCase', 'UpperCase', '|',
                    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
                    'Outdent', 'Indent', '|',
                    'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
                    'SourceCode', 'FullScreen', '|', 'Undo', 'Redo'
                ]
            },
            dataList: [
                'Artículo',
                'Sección',
                'Cláusula',
                'Título',
            ],
            tenants: [],
            fieldsSourceProcess: {text : "razonSocial", value: 'TID'},
            disabledButton: false,
            spinSettings: { position: 'Right', width: 20 },
            formData: {
                prefix: '',
                article: '',
                standard_type: '',
                number: '',
                content: '',
            },
            fieldStandard: {text: "text", value: 'id' },
            listStandard: [
                {id: 'ACUE', text: 'Acuerdo'},
                {id: 'AUTO', text: 'Auto'},
                {id: 'CIRC', text: 'Circular'},
                {id: 'CONS', text: 'ConstituciónNacional'},
                {id: 'CONT', text: 'Contrato'},
                {id: 'DECI', text: 'DecisiónAndina'},
                {id: 'DECR', text: 'Decreto'},
                {id: 'DIR', text: 'Directiva'},
                {id: 'INS', text: 'Instructivo'},
                {id: 'LEY', text: 'Ley'},
                {id: 'MAN', text: 'Manual'},
                {id: 'NINT', text: 'Norma Interna'},
                {id: 'NISO', text: 'Norma ISO'},
                {id: 'NT', text: 'NormaTecnica'},
                {id: 'OFI', text: 'Oficio'},
                {id: 'ORDE', text: 'Ordenanza'},
                {id: 'PACU', text: 'Proyecto de Acuerdo'},
                {id: 'PDEC', text: 'Proyecto de Decreto'},
                {id: 'PORD', text: 'Proyecto de Ordenanza'},
                {id: 'PRES', text: 'Proyecto de Resolución'},
                {id: 'PLEY', text: 'ProyectoLey'},
                {id: 'RESO', text: 'Resolución'},
                {id: 'SENT', text: 'Sentencia'},
                {id: 'TRAT', text: 'Tratado'},
            ]

        }
    },
    methods: {
        /**
         * Guarda los datos
         */
        validateSubmit() {
            this.disabledButton = true;
            this.$refs.progressBtnFormUsers.enable;
            axios.post('/auth/rules/saveRule',{
                data: this.formData,
                compliance: this.data
            }).then((response) => {
                Vue.prototype.$eventHub.$emit('closeSidebarClick');
                this.disabledButton = false;
                Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                Vue.prototype.$eventHub.$emit('onAdminRules');
                Vue.prototype.$eventHub.$emit('onGetCompliance');
                if(this.data.id != undefined){
                    this.$eventHub.$emit("toggleSidebarClick","Asociar Norma","add-rule-compliance",this.data,"mw-100");
                }
            }).catch(error => {
                this.$eventHub.$emit("showToastNotification", error);
            });
        },
        /**
         * Consulta los tenants
         */
        getTenants(){
            axios.post('/auth/tenants/getTenants', {
                global_filters: localStorage.getItem('global_filters')
            }).then((response) => {
                this.tenants = response.data;
            });
        },

        /**
         * Loader
         */
        progress: function() {
            if(this.disabledButton == false){
                this.$refs.progressBtnFormUsers.stop();
            }
        },

        imageSelected(args) {
            const tenant = this.formData.tenant;
            const file = args.filesData[0];
            const formData = new FormData();
            formData.append('rawFile', file.rawFile);
            formData.append('TID', tenant);

            this.$eventHub.$emit('showToastNotification', {message: "Cargando imágen"});

            const rteObj = this.$refs.defaultRTE.ej2Instances;

            axios.post('/auth/norms/uploadImg', formData)
                .then(response => {
                    const imageUrl = response.data.path;
                    rteObj.executeCommand('insertImage', { url: imageUrl, width: 'auto', height: 'auto', altText: file.name });
                    args.cancel = true;
                    rteObj.imageModule.dialogObj.close(); 
                })
                .catch(error => {
                    this.$eventHub.$emit('showToastNotification', {status: "error", message: "Error al subir la imagen"});
                    console.error("Error uploading image:");
                });
        }
    },
    mounted() {
        this.getTenants();
    }
}
</script>
<style>
    @import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
    @import "../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
    @import "../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
    @import "../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
    @import "../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
    @import "../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
    @import "../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
    @import "../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
</style>